<template>
  <div>
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerSlider.TITLE"
      tag="h2"
    />
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerSlider.DESCRIPTION"
      tag="div"
    />

    <div class="slider banner-slider">
      <swiper :options="swiperOption" ref="swiperRef">
        <swiper-slide v-for="proposal in config.proposals" :key="proposal.id">
          <component
            :is="getProposalModelName(proposal)"
            :proposal="proposal"
            :position="config.templateBlock.codInt"
          />
        </swiper-slide>
      </swiper>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_BULLETS',
            true
          ) && config.proposals.length > 1
        "
        :id="`banner-pagination-${config.categoryBlockId}`"
        class="swiper-pagination"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-prev-${config.categoryBlockId}`"
        class="swiper-button-prev"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-next-${config.categoryBlockId}`"
        class="swiper-button-next"
      ></div>
    </div>
  </div>
</template>
<style lang="scss">
.banner-slider {
  position: relative;
  .swiper-slide {
    height: auto;
    .proposal-card.v-card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .swiper-container {
      margin: 0 -8px;
      padding: 0 8px;
    }
  }
}
</style>
<script>
import ProposalImage from "./elements/ProposalImage.vue";
import ProposalCard from "./elements/ProposalCard.vue";
import ProposalButton from "./elements/ProposalButton.vue";
import ProposalHorizontalButton from "./elements/ProposalHorizontalButton.vue";
import CustomerCard from "./elements/CustomerCard.vue";
import CustomerCardHorizontal from "./elements/CustomerCardHorizontal.vue";

import deliveryReactive from "~/mixins/deliveryReactive";
import categoryBlockType from "./categoryBlockType";

export default {
  name: "BannerSlider",
  props: {
    config: { type: Object, required: true },
    container: { type: Boolean, default: true }
  },
  components: {
    ProposalImage,
    ProposalCard,
    ProposalButton,
    ProposalHorizontalButton,
    CustomerCard,
    CustomerCardHorizontal
  },
  mixins: [deliveryReactive, categoryBlockType],
  data() {
    return {
      swiperRef: null,
      swiperDefaultOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: true,
        watchOverflow: true,
        loop: false,
        pagination: {
          el: `#banner-pagination-${this.config.categoryBlockId}`,
          clickable: true
        },
        navigation: {
          prevEl: `#banner-slider-prev-${this.config.categoryBlockId}`,
          nextEl: `#banner-slider-next-${this.config.categoryBlockId}`
        }
      }
    };
  },
  methods: {
    reload() {
      if (this.$refs.swiperRef.swiperInstance) {
        this.$refs.swiperRef.swiperInstance.slideTo(0);
      }
      if (!this.config.proposals || this.config.proposals.length < 1) {
        this.$emit("hide");
      }
    }
  },
  created() {
    this.$emit("hide");
  }
};
</script>
